/**
 * 用户编辑功能
 * @Author:xyguo
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool,component_tool } from '@/tool'
let { WizForm } = component_tool
import { modelUtils } from "@/utils";

let {
  WizContainer,
} = framework_tool;

class UserUpdate extends WizContainer {
  componentName = 'UserUpdate';

  constructor(props) {
    super(props);
    this.state = {};
  }

  propsAndStateOnChange = {
    result: this._userUpdateState.bind(this)
  };

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _userUpdateState(nextProps, nextState) {
    if (nextProps.result.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false);
      this.doAction({
        path: "userManagement/userList",
        payload: {
          key: "userManagement@userList",
          apiParams: {pageNum: 1, pageSize: 10}
        }
      });
    } else {
      wizNotice.error(nextProps.result.msg);
    }
  }

  /**
   * 用户编辑
   */
  _userUpdate = () => {
    this.formData.validateFields((err, values) => {
      if (!err) {
        this.doAction({
          path: "userManagement/updateUser",
          payload: {
            key: "updateUserKey",
            apiParams: {
              ...values
            }
          }
        });
      }
      return
    });
  };

  _userReset = () => {
     this.formData.resetFields();
    // this.doAction({
    //   path: "userManagement/userList",
    //   payload: {
    //     key: "userManagement@userList",
    //     apiParams: {pageNum: 1, pageSize: 10}
    //   }
    // });
  }

  _render() {
    return <WizForm
      {...this.props}
      ref={r => {
        this.formData = r
      }}
    />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userManagement } = state;
  const result = modelUtils.getModelEntity(userManagement, "updateUserKey");
  return {
    result: result
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(UserUpdate);
